import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalOptions, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { Globals } from '@app/service/globals.service';
import { MemberListService } from '@app/home/service/member.list.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-member-view',
  templateUrl: './member-view.component.html',
  styleUrls: ['./member-view.component.scss']
})
export class MemberViewComponent implements OnInit {

  public seq: any = 0;
  public data: any = {};

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    public activeModal: NgbActiveModal,
    private memberListService: MemberListService,
    private globals: Globals,
    private toastrService: ToastrService
  ) {

  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.getCompanyDetail();
  }

  /*******************************************************************************
    설  명 : 회원사 현황 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getCompanyDetail() {
    if( this.seq == 0 ) {
      this.toastrService.error( "데이터를 불러오는데 실패하였습니다.", "에러" );
      this.activeModal.dismiss();

      return false;
    }

    // indicator 표시 숨김
    setTimeout (() => {
      this.globals.indicator.next(true);
    });

    this.memberListService.getCompanyDetail( this.seq ).then( response => {
      if( response.ResultCode ) {
        this.data = response.data;
      } else {
        this.toastrService.error( "데이터를 불러오는데 실패하였습니다.", "에러" );
        this.activeModal.dismiss();
      }

      this.globals.indicator.next(false);
    });
  }

}
